import { IconStyle } from '@repo/ui/components/Icon';
import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const InviteFriendsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;

  position: relative;
  min-height: 352px;

  * {
    text-align: left;
  }
`;

export const Instructions = styled.ul`
  margin: 0;
  padding-inline-start: 20px;

  li + li {
    margin-top: 6px;
  }

  li {
    color: ${themeStyle.varInkMain};
  }

  ${QUERIES.tabletAndUp} {
    max-width: 270px;
  }

  // Need to use hardcoded value as it is in-between tablet sizes
  @media (min-width: 880px) {
    max-width: 380px;
  }
`;

export const ImageWrapper = styled.div<{ isNewDesignEnabled: boolean }>`
  ${QUERIES.largeTabletAndUp} {
    z-index: 1;
    position: absolute;
    top: ${({ isNewDesignEnabled }) => (isNewDesignEnabled ? '15px' : '22px')};
    right: 0px;
    max-width: 300px;
  }

  // Need to use hardcoded value as it is in-between tablet sizes
  @media (min-width: 880px) {
    top: ${({ isNewDesignEnabled }) => (isNewDesignEnabled ? '0px' : '22px')};
    max-width: 315px;
  }
`;

export const InvitationActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${themeStyle.varBackgroundAlt};
  border-radius: ${themeStyle.radiusLarge};
  box-shadow: ${themeStyle.varShadowSmallHeavy};

  padding: 18px;
  ${QUERIES.largeTabletAndUp} {
    padding: 32px;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;

  ${QUERIES.tabletAndUp} {
    align-items: start;
  }

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 30% 65%;
    gap: 5%;
    align-items: center;
  }
`;

export const InputButtonWrapper = styled.div`
  position: relative;
  width: 100%;

  ${IconStyle} {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 11px;
  right: 10px;
`;

export const Divider = styled.div`
  position: relative;
  width: 100%;
  height: 1px;
  background-color: ${themeStyle.varInkLight};
  html[data-theme='dark'] &&,
  .dark && {
    background-color: 1px solid ${themeStyle.varInkSuperLight};
  }

  margin: 30px 0;

  display: flex;
  align-items: center;
  justify-content: center;

  ${P2} {
    padding: 0 10px;
    background-color: ${themeStyle.varBackgroundAlt};
  }

  ${QUERIES.largeTabletAndUp} {
    margin: 30px 0;
  }
`;

export const LinkCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;

  width: 100%;

  ${QUERIES.tabletAndUp} {
    flex-direction: row;

    gap: 12px;
  }

  ${QUERIES.laptopAndUp} {
    width: unset;
  }
`;

export const LinkButtonsWrapper = styled(FlexRow)`
  gap: 8px;

  ${QUERIES.largeTabletAndUp} {
    gap: 12px;
  }
`;

export const CopyLinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${themeStyle.radiusMedium};
  height: 40px;
  font-weight: ${themeStyle.fontMedium};
  cursor: pointer;
  width: 100%;
  gap: 8px;
  min-width: 0;

  background: ${themeStyle.varBackgroundBase};
  border: 1px solid ${themeStyle.varInkLight};

  .link {
    max-width: 325px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ${QUERIES.tabletAndUp} {
    padding: 11px;
    height: 53px;
  }

  ${QUERIES.laptopAndUp} {
    max-width: 392px;
  }
`;

export const CopyLinkButtonMobileWrapper = styled.div`
  ${QUERIES.tabletAndUp} {
    display: none;
  }
`;
